import navPanel from '../../components/nav-panel/nav-panel';
import zigzagPanel from '../../components/zig-zag-menu/zig-zag-menu';
import navDesktop from '../../components/nav-desktop/nav-desktop';
import navMobile from '../../components/nav-mobile/nav-mobile';
import topBar from '../../components/top-bar/top-bar';
import crisisMessageNotification from '../../components/crisis-message/crisis-message';
import accordions from '../../blocks/accordion/accordion';
import tableSort from '../../blocks/fincchta-table/fincchta-table';
import extendedAccordions from '../../blocks/extended-accordion/extended-accordion';
import linkToStart from '../../components/link-to-start/link-to-start';
import nav from '../../components/nav/nav';
import scrollToTop from '../../components/scroll-to-top/scroll-to-top';
import serviceSearch from '../../blocks/service-search/service-search';
import localServiceSearch from '../../blocks/local-service-search/local-service-search';
import assessmentSearch from '../../blocks/assessment-search/assessment-search';
import localNavigationStrip from '../../blocks/local-navigation-strip/local-navigation-strip';
import articleArchive from '../../blocks/article-archive/article-archive';
// import globalModal from '../../components/global-modal/global-modal';
import mappage from '../../components/map-page/map-page';
import serviceLocationDropdown from '../../blocks/servicelocations/servicelocations';

const appStart = () => {
  navPanel.init();
  zigzagPanel.init();
  navMobile.init();
  navDesktop.init();
  topBar.init();
  localNavigationStrip.init();
  tableSort();

  scrollToTop();
  accordions();
  extendedAccordions();
  linkToStart();
  nav();
  crisisMessageNotification();
  serviceSearch();
  localServiceSearch();
  assessmentSearch();
  articleArchive();
  // globalModal();
  mappage();
  serviceLocationDropdown();

  [...document.querySelectorAll('[data-action="scroll-to-top"]')].forEach((a) => {
    a.addEventListener('click', () => { window.scrollTo(0, 0); });
  });
};

// 'DOMContentLoaded' may fire before your script has a chance to run.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', appStart);
} else {
  appStart();
}